class ChatLauncher extends HTMLElement {
  loadGorgiasScript() {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.setAttribute('id', 'gorgias-chat-widget-install-v3');
      script.async = true;
      script.src = `https://config.gorgias.chat/bundle-loader/${this.dataset.apiId}`;
      script.onload = () => resolve(script);
      script.onerror = () => reject(new Error('Failed to load Gorgias script.'));

      document.head.appendChild(script);
    });
  }

  setLabelsToClosedState() {
    document.querySelectorAll('chat-launcher').forEach((chatLauncher) => {
      chatLauncher.button.textContent = this.dataset.closedStateMessage;
    });
  }

  setLabelsToOpenedState() {
    document.querySelectorAll('chat-launcher').forEach((chatLauncher) => {
      chatLauncher.button.textContent = this.dataset.openedStateMessage;
    });
  }

  connectedCallback() {
    this.button = this.querySelector('a, button');

    if (this.button) {
      this.button.addEventListener('click', (ev) => {
        ev.preventDefault();
        if ('GorgiasChat' in window) {
          window.GorgiasChat.isOpen() ? window.GorgiasChat.close() : window.GorgiasChat.open();
        } else {
          this.loadGorgiasScript().then(() => {
            let initGorgiasChatPromise = window.GorgiasChat
              ? window.GorgiasChat.init()
              : new Promise((resolve) => {
                  window.addEventListener('gorgias-widget-loaded', () => {
                    resolve();
                  });
                });
            initGorgiasChatPromise.then(() => {
              window.GorgiasChat.hidePoweredBy(true);
              window.GorgiasChat.on('widget:opened', (ev) => {
                this.setLabelsToOpenedState();
              });
              window.GorgiasChat.on('widget:closed', (ev) => {
                this.setLabelsToClosedState();
              });

              window.GorgiasChat.open();
            });
          });
        }
      });
    }
  }

  setOpen() {
    this.setCloseLabel();
    window.GorgiasChat.open();
  }

  setClosed() {
    this.setOpenLabel();
    window.GorgiasChat.close();
  }

  setCloseLabel() {
    this.button.textContent = this.dataset.closeChat;
  }

  setOpenLabel() {
    this.button.textContent = this.dataset.openChat;
  }
}

customElements.define('chat-launcher', ChatLauncher);
